import { render, staticRenderFns } from "./CertifiedConsultant.vue?vue&type=template&id=2b007fb1&scoped=true"
import script from "./CertifiedConsultant.vue?vue&type=script&lang=js"
export * from "./CertifiedConsultant.vue?vue&type=script&lang=js"
import style0 from "./CertifiedConsultant.vue?vue&type=style&index=0&id=2b007fb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b007fb1",
  null
  
)

export default component.exports